import { perf } from './performance';

export default class ChannelBuffer {
    #messages = [];
    #mainBufferId = 'MAIN';
    #id;

    constructor(transactionId) {
        this.#id = transactionId ?? this.#mainBufferId;
    }
    isEmpty() {
        return !this.#messages.length;
    }
    put(message) {
        this.#messages.push(message);
        this.#log(
            `put(): transactionId=${message?.payload?.truck_transaction_id}, version=${
                message?.payload?.version
            }, put to buffer, buffer size=${this.#messages.length} `
        );
        perf.mark(message.payload, this.#getPerformanceMeasureType(true));
    }
    take() {
        const message = this.#messages.shift();
        this.#log(
            `take(): BufferId=${this.#id}, transactionId=${message?.payload?.truck_transaction_id}, version=${
                message?.payload?.version
            } taken from buffer, buffer size=${this.#messages.length} `
        );
        perf.mark(message.payload, this.#getPerformanceMeasureType());
        return message;
    }

    #getPerformanceMeasureType(typePut = false) {
        if (typePut) return this.#id === this.#mainBufferId ? perf.markNames.putToMainBuffer : perf.markNames.putToDedicatedBuffer;
        return this.#id === this.#mainBufferId ? perf.markNames.takenFromMainBuffer : perf.markNames.takenFromDedicatedBuffer;
    }

    #log(message, mode = 'log') {
        console[mode](`[ChannelBuffer, id=${this.#id}] ${message}`);
    }
}
